import { Outlet, ScrollRestoration } from "react-router";

/** Top-level route element shared by public pages and the app shell. */
export function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
}
